
$(function() {
    var res = location.search.substr(1).split("&");

    var a = $.inArray("adv=1", res);
    if (a > -1) {
        $('.activities-search-advanced table tbody')
        .each(function (index, e) {
            if (!$(this).hasClass('collapsed')) {
                $(this).closest('tbody').find('td').hide();
            }
            else {
                $(this).closest('tbody').find('td').hide();
            }
            if ($(this).hasClass('submitButton') && !$(this).hasClass('collapsed')) {
                $(this).addClass('expanded');
                $(this).closest('tbody').find('td').show();
            }
        });

        $('.activities-search-advanced table tbody')
            .find('th').click(function () {
                var tbody = $(this).closest('tbody');
                tbody.find('td').toggle();
                if (tbody.hasClass('collapsed')) {
                    tbody.removeClass('collapsed').addClass('expanded');
                }
                else if (tbody.hasClass('expanded')) {
                    tbody.removeClass('expanded').addClass('collapsed');
                }
            })

        $('.activities-search-advanced')
            .find(':checkbox').each(function (index, e) {
                if ($(e).is(':checked')) {
                    var tbody = $(this).closest('tbody');
                    var hdr = tbody.find('th');
                    var cspan = hdr.find('span.count');
                    if (cspan.length === 0) {
                        cspan = $("<span></span>").attr('class', 'count').appendTo(hdr);
                    }

                    var chkcount = tbody.find(':checked').length;
                    if (chkcount === 0) cspan.hide();
                    else cspan.show();
                    cspan.text(chkcount);
                    //setCount(chkcount);
                }
            });
    }
    else {
        $('.activities-search-advanced table tbody')
            .each(function (index, e) {
                if (!$(this).hasClass('collapsed') && !$(this).hasClass('submitButton')) {
                    $(this).addClass('expanded');
                }
                if ($(this).hasClass('collapsed')) {
                    $(this).closest('tbody').find('td').hide();
                }
                else {
                    $(this).closest('tbody').find('td').show();
                }
            });
        $('.activities-search-advanced table tbody')
            .find('th').click(function () {
                var tbody = $(this).closest('tbody');
                tbody.find('td').toggle();
                if (tbody.hasClass('collapsed')) {
                    tbody.removeClass('collapsed').addClass('expanded');
                }
                else if (tbody.hasClass('expanded')) {
                    tbody.removeClass('expanded').addClass('collapsed');
                }
            })

        $('.activities-search-advanced')
            .find(':checkbox').each(function (index, e) {
                $(e).change(function () {
                    var tbody = $(this).closest('tbody');
                    var hdr = tbody.find('th');
                    var cspan = hdr.find('span.count');
                    if (cspan.length === 0) {
                        cspan = $("<span></span>").attr('class', 'count').appendTo(hdr);
                        //    				$.create('span')
                        //    				.addClass('count')
                        //    				.appendTo(hdr);
                    }

                    var chkcount = tbody.find(':checked').length;
                    if (chkcount === 0) cspan.hide();
                    else cspan.show();
                    cspan.text(chkcount);
                });
            });
    }


    $('.activities-search-advanced')
        .find(':checkbox').each(function (index, e) {
            $(e).change(function () {
                var tbody = $(this).closest('tbody');
                var hdr = tbody.find('th');
                var cspan = hdr.find('span.count');
                if (cspan.length === 0) {
                    cspan = $("<span></span>").attr('class', 'count').appendTo(hdr);
                    //    			$.create('span')
                    //    			.addClass('count')
                    //    			.appendTo(hdr);
                }

                var chkcount = tbody.find(':checked').length;
                if (chkcount === 0) cspan.hide();
                else cspan.show();
                cspan.text(chkcount);
            });
        });

});